import Navbar from '@app/components/layout/nav/navbar';
import Page from '@app/components/layout/page/page';
import { cn } from '@shared/lib/utils';
import { useHistory } from '@shared/providers/history-provider';
import { QueryStatus } from '@tanstack/react-query';
import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

interface GuideLayoutProps<T> {
  children?: React.ReactNode;
  pageName: string;
  className?: string;
  onClosePath: string;
  context?: T;
  includeCloseButton?: boolean;
  useReferrer?: boolean;
  status?: QueryStatus;
}

export default function GuideLayout<T>({
  children,
  pageName,
  className,
  onClosePath,
  context,
  includeCloseButton = true,
  useReferrer = true,
  status,
}: GuideLayoutProps<T>) {
  const navigate = useNavigate();
  const history = useHistory();
  const [referrer] = useState<string | undefined>(history.previousLocation);

  return (
    <Page name={pageName} page="guide" status={status}>
      <div
        className={cn(
          'flex h-full min-h-screen flex-col bg-gradient-to-r from-teal-300 to-teal-100',
          className
        )}
      >
        <Navbar
          logo={{
            variant: 'name',
            color: 'dark',
          }}
          includeCloseButton={includeCloseButton}
          closeButtonProps={{
            onClick: () =>
              navigate(
                useReferrer && referrer && referrer !== '/reporting-period'
                  ? referrer
                  : onClosePath
              ),
          }}
        />
        <div className="grid flex-1 grid-cols-1 overflow-y-auto p-2">
          {children ? children : <Outlet context={context} />}
        </div>
      </div>
    </Page>
  );
}
